import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import styled from "styled-components";
import Navbar from "../components/Navbar";
import Welcome from "./Welcome";
import About from "./About";
import Research from "./Research";
import Papers from "./Papers";
import Presentations from "./Presentations";
import Footer from "../components/Footer";
import CV from "./CurriculumVitae";

const SiteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100vw - 30vw);
  margin: 2% 15% 10% 15%;
  background-color: white;
  box-shadow: 20px black;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.15);
`;

const Home = () => {
  return (
    <SiteWrapper>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/research" element={<Research />} />
          <Route path="/publications" element={<Papers />} />
          <Route path="/presentations" element={<Presentations />} />
          <Route path="/cv" element={<CV />} />
          <Route path="/" element={<Welcome />} />
        </Routes>
      </BrowserRouter>
      <Footer />
    </SiteWrapper>
  );
};

export default Home;
